import './tableView/_live-view-pop-up.scss'

import React, {useCallback, useEffect, useState} from "react";
import {useLiveViewContext} from "./LiveViewProvider";
import MapBaseLayout from "../maps/MapBaseLayout";
import ENUMS from "../../../utils/ENUMS";
// import {PLAYERS_LIVE_DATA} from "./data";
import {Marker, Popup} from "react-leaflet";
import L from "leaflet";
import MapLiveViewMeta from "./MapLiveViewMeta";
import {fetchPlayersLive, resetPlayerData, sendPlayerAlert} from './live.view.api.services';
import {mapPlayerLiveView} from "./live.view.data.services";
import {toast, ToastContainer} from 'react-toastify';

const {MAPS} = ENUMS


const PlayerView = ({data}) => {

    const {group_alerts_count, user, opponents, status, hole} = data;

    const {name, lat, lng} = user || {}

    const {color, label} = status || {}


    const renderPlayersData = useCallback(() => {

        const resetPlayer = async () => {
            const player_data = {
                "user_id": user.id,
                "hole_id": hole.id,
                "match_id": user.golf_match
            }
            try {
                const res = await resetPlayerData(player_data);
                if (res.data.status === "SUCCESS") {
                    toast.success("Player reset successfully.");
                }
            } catch (err) {
                console.log(err);
                toast.error("Error");
            }
            // console.log(res, "response");
        }

        const sendAlert = async () => {
            const alert_data = {
                send_to: user.id,
                alert_type: status.alert_type,
                holepoint: hole.id,
                match_id: user.golf_match
            }
            try {
                const res = await sendPlayerAlert(alert_data);
                if (res.data.status === "SUCCESS") {
                    toast.success("Alert Sent successfully.");
                }
            } catch (err) {
                console.log(err);
                toast.error("Error");
            }
            // console.log(res, "response");
        }

        return (
            <div className='plv-popup'>

                <div className='plv-popup__body'>

                    <div className='plv-popup__row'>

                        <h5
                            className='plv-popup__label'
                            style={{color}}
                        >
                            {label}:
                        </h5>

                        <span className='plv-popup__value'> {name}</span>

                    </div>

                    <div className='plv-popup__row'>

                        <h5 className='plv-popup__label'>
                            Players:
                        </h5>

                        <span className='plv-popup__value'>
                            {name}

                            {
                                opponents.length > 0 && (
                                    <>
                                        {opponents.map(({name}) => <>, {name}</>)}
                                    </>
                                )
                            }
                        </span>
                    </div>

                    <div className='plv-popup__row'>

                        <h5 className='plv-popup__label'>
                            Group Alerts Today:
                        </h5>

                        <span className='plv-popup__value'> {group_alerts_count}</span>
                    </div>

                </div>

                <div className='plv-popup__footer'>

                    <h5 className='plv-popup__label'>
                        Send group Alert:
                    </h5>

                    <div className="plv-popup__row plv-popup__btn">
                        <button disabled={label === "on-time"}
                                className={label === "on-time" ? "res-btn-gray plv-popup__btn--reset" : "res-btn-primary plv-popup__btn--send"}
                                onClick={sendAlert}>SEND ALERT
                        </button>
                        <button className="res-btn-gray plv-popup__btn--reset" onClick={resetPlayer}>RESET PLAYER
                        </button>
                    </div>

                </div>

            </div>
        )
    }, [data])

    const renderIcon = useCallback(() => {

        // Render delay layout
        if (label === 'Delay') return L.divIcon({
            className: '',
            html: `
                <div style='height : 100%;width : 100%;'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="43" viewBox="0 0 50 43">
                      <g id="Group_6877" data-name="Group 6877" transform="translate(-530 -1268)">
                        <g id="Polygon_29" data-name="Polygon 29" transform="translate(530 1268)" fill="${color}" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M 41.30937957763672 42 L 8.690620422363281 42 C 7.242020130157471 42 5.945889949798584 41.25037002563477 5.223490238189697 39.99474716186523 C 4.501090049743652 38.73912811279297 4.504489898681641 37.24184799194336 5.232590198516846 35.98951721191406 L 21.54196929931641 7.93738842010498 C 22.26626014709473 6.691608428955078 23.55898094177246 5.947868347167969 25 5.947868347167969 C 26.44101905822754 5.947868347167969 27.73373985290527 6.691608428955078 28.4580192565918 7.93738842010498 L 44.76741027832031 35.98951721191406 C 45.49551010131836 37.24184799194336 45.49890899658203 38.73912811279297 44.77650833129883 39.99474716186523 C 44.05411148071289 41.25037002563477 42.75799179077148 42 41.30937957763672 42 Z" stroke="none"/>
                          <path d="M 25 6.947856903076172 C 23.91922950744629 6.947856903076172 22.9496898651123 7.505668640136719 22.40646934509277 8.439998626708984 L 6.097091674804688 36.49213790893555 C 5.551021575927734 37.43138885498047 5.548469543457031 38.55434799194336 6.09027099609375 39.49605941772461 C 6.632068634033203 40.43777847290039 7.604171752929688 41 8.690620422363281 41 L 41.30937957763672 41 C 42.39582824707031 41 43.367919921875 40.43777847290039 43.90972900390625 39.49605941772461 C 44.45153045654297 38.55434799194336 44.44897842407227 37.43137741088867 43.90290832519531 36.49213790893555 L 27.59350967407227 8.439998626708984 C 27.05030059814453 7.505668640136719 26.08075904846191 6.947856903076172 25 6.947856903076172 M 24.99999809265137 4.947864532470703 C 26.6793098449707 4.947864532470703 28.35861968994141 5.776828765869141 29.32253074645996 7.434757232666016 L 45.63191986083984 35.48690032958984 C 47.56988906860352 38.82020950317383 45.16511154174805 43 41.30937957763672 43 L 8.690620422363281 43 C 4.834880828857422 43 2.430110931396484 38.82020950317383 4.368080139160156 35.48690032958984 L 20.67745971679688 7.434757232666016 C 21.6413745880127 5.776828765869141 23.32068824768066 4.947864532470703 24.99999809265137 4.947864532470703 Z" stroke="none" fill="#fff"/>
                        </g>
                        <text id="_" data-name="!" transform="translate(551 1304)" fill="#fff" font-size="25" font-family="Helvetica" letter-spacing="0.1em"><tspan x="0" y="0">!</tspan></text>
                      </g>
                    </svg>
                </div>
            `,
            iconSize: [10, 10],
            iconAnchor: [5, 10]
        })

        return L.divIcon({
            className: '',
            html: `<div style='background-color:${color};height : 100%;width : 100%;border-radius: 50%'/>`,
            iconSize: [20, 20],
            iconAnchor: [10, 20]
        })

    }, [status])


    return (
        <Marker
            position={[lat, lng]}
            msg={renderPlayersData()}
            zIndexOffset={999}
            icon={renderIcon()}
        >
            <Popup className='plv-popup__container' opacity={1}>
                {renderPlayersData()}
            </Popup>
        </Marker>
    )

}

export const MapLiveView = ({ isActive }) => {
    const { state, setState } = useLiveViewContext();
    const [geoJsonDataList, setGeoJsonDataList] = useState([]);
    const [isCourseMapped, setIsCourseMapped] = useState(false);
    const [centroid, setCentroid] = useState([]);
    const [selectedHole, setSelectedHole] = useState(null);
    const [showAllHoles, setShowAllHoles] = useState(true);

    const { courseData, courseLoading, playersLiveData, liveDataLoading, selectedCourse } = state;
    const { course_name = "", id, hole_details } = courseData || {};
    const { hole_coords_data } = playersLiveData || {};
    const holepoints = hole_coords_data?.holepoints || [];

    console.log("Course Data:", courseData);

    useEffect(() => {
        if (!hole_details) return;

        const _geoJsonDataList = hole_details
            .filter(({ coordinate }) => coordinate?.features?.length)
            .map(({ coordinate }) => coordinate);

        if (_geoJsonDataList.length > 0) {
            const firstFeature = _geoJsonDataList[0].features.find(
                (f) => f.geometry.type === "Point" || f.geometry.type === "Polygon"
            );

            if (firstFeature) {
                try {
                    const [lng, lat] =
                        firstFeature.geometry.type === "Point"
                            ? firstFeature.geometry.coordinates
                            : firstFeature.geometry.coordinates[0][0];
                    setCentroid([lat, lng]);
                } catch (e) {
                    console.error("Centroid Error:", e);
                }
            }
        }

        setGeoJsonDataList(_geoJsonDataList);
    }, [hole_details, courseData]);

    const updateGeoJsonData = (holeIndex) => {
        if (!hole_details) return;

        console.log("Updating GeoJSON for Hole Index:", holeIndex);

        const filteredGeoJson = hole_details
            .filter(({ coordinate, hole_index }) => {
                if (!coordinate?.features) return false;
                return Number(hole_index) === Number(holeIndex);
            })
            .map(({ coordinate }) => coordinate);

        console.log("Filtered GeoJSON Data:", filteredGeoJson);

        if (filteredGeoJson.length) {
            setGeoJsonDataList(filteredGeoJson);
            console.log("GeoJSON Updated:", filteredGeoJson);

            try {
                const firstFeature = filteredGeoJson[0].features.find(
                    (f) => f.geometry.type === "Point" || f.geometry.type === "Polygon"
                );

                if (firstFeature) {
                    const [lng, lat] =
                        firstFeature.geometry.type === "Point"
                            ? firstFeature.geometry.coordinates
                            : firstFeature.geometry.coordinates[0][0];
                    setCentroid([lat, lng]);
                    console.log("Updated Centroid:", [lat, lng]);
                }
            } catch (e) {
                console.error("Centroid Error:", e);
            }
        } else {
            console.warn("No GeoJSON Data Found for Selected Hole");
        }
    };

    const fetchPlayersLiveData = async () => {
        try {
            setState((prevState) => ({
                ...prevState,
                liveDataLoading: true,
            }));

            const res = await fetchPlayersLive(id);
            const liveData = mapPlayerLiveView(res.data.data);

            setState((prevState) => ({
                ...prevState,
                playersLiveData: liveData,
            }));
        } catch (e) {
            console.error("Error fetching live data:", e);
        } finally {
            setState((prevState) => ({
                ...prevState,
                liveDataLoading: false,
            }));
        }
    };

    useEffect(() => {
        let liveDataInterval;

        if (geoJsonDataList.length) {
            setIsCourseMapped(true);
            fetchPlayersLiveData();
            liveDataInterval = setInterval(fetchPlayersLiveData, 1000);
        } else {
            setIsCourseMapped(false);
        }

        return () => {
            if (liveDataInterval) clearInterval(liveDataInterval);
        };
    }, [geoJsonDataList, id, selectedCourse]);

  

    useEffect(() => {
        if (showAllHoles && hole_details) {
            setGeoJsonDataList(hole_details.map(({ coordinate }) => coordinate)); 
        }
    }, [showAllHoles, hole_details]);

    if (courseLoading || !courseData) return <p>Loading...</p>;

    return (
        <div className={isActive ? "content active-content" : "content"}>
            <MapLiveViewMeta />
            <style>
                {`
               
                `}
            </style>
            <div className='liveview'>
                {isCourseMapped ? (
                    <>
                        <MapBaseLayout
                            center={
                                centroid.length === 0
                                    ? [MAPS.DEFAULT_LAT, MAPS.DEFAULT_LNG]
                                    : centroid
                            }
                            zoom={MAPS.ZOOM_LEVEL}
                            style={{ height: "50vh", width: "100%", minHeight: "50rem" }}
                            geoJsonData={geoJsonDataList}
                        >
                            {playersLiveData?.players?.length > 0 &&
                                playersLiveData.players.map((player, index) => (
                                    <PlayerView data={player} key={index.toString()} />
                                ))}
                        </MapBaseLayout>
                        <div className="c-mapping__box__btn">

                        <button
                        style={{ marginTop: "20px",marginBottom:"20px",
                            paddingLeft:"20px",
                            paddingRight:"20px",width :"220px"
                         }}
                                    className={`hole_btn ${showAllHoles ? "active" : ""}`}
                                    onClick={() => {
                                        
                                        setShowAllHoles(true);
                                        setSelectedHole(null);
                                    }}
                                >
                                    Show All Holes
                                </button>
                                </div>
                        {holepoints.length > 0 && (

                            <div className="c-mapping__box__btn">
                                {holepoints.map((hole) => (
                                    <button
                                        key={hole.hole_id}
                                        className={`hole_btn ${selectedHole === hole.hole_index ? "active" : ""}`}
                                        onClick={() => {
                                            setSelectedHole(hole.hole_index);
                                            setShowAllHoles(false);
                                            updateGeoJsonData(hole.hole_index);
                                        }}
                                    >
                                        Hole {hole.hole_index}
                                    </button>
                                ))}
                          
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-jost-sb-20">Please Map Courses to see Live View Map</div>
                )}
            </div>
        </div>
    );
};




